import React from 'react'
import { CFooter } from '@coreui/react'

const TheFooter = () => {
  return (
    <CFooter fixed={false}>
      <div style={{float:'right'}}>
        <span className="mr-1">Powered by</span>
        <a href="https://www.3pm-solution.com/" target="_blank" alt="3PM IT Solutions">3PM IT Solutions</a>
      </div>
    </CFooter>
  )
}

export default React.memo(TheFooter)
